import React, { useState } from "react";

const ModalContainer = ({ children, autoOpen = false }) => {
    const [showModal, setShowModal] = useState(false);

    // Effect for auto-opening the modal on page load
    React.useEffect(() => {
        if (autoOpen) {
            // Small delay to ensure the page has loaded
            const timer = setTimeout(() => {
                setShowModal(true);
            }, 500);

            return () => clearTimeout(timer);
        }
    }, [autoOpen]);

    const openModal = () => setShowModal(true);
    const closeModal = () => setShowModal(false);

    return children({ showModal, openModal, closeModal });
};

export default ModalContainer;